import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { useAuthStore } from "@/stores/auth";
import "@/styles/tokens.css";
import "@/styles/main.css";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

function renderBootstrapFailure(): void {
  const target = document.querySelector<HTMLElement>("#app");
  if (target === null) {
    return;
  }

  const screen = document.createElement("div");
  screen.className = "boot-screen";
  screen.setAttribute("role", "alert");

  const content = document.createElement("div");
  content.className = "boot-screen-content";

  const title = document.createElement("strong");
  title.textContent = "Washbox could not start";

  const message = document.createElement("p");
  message.textContent = "Reload this page to try again.";

  const retry = document.createElement("button");
  retry.className = "button button-secondary";
  retry.type = "button";
  retry.textContent = "Reload";
  retry.addEventListener("click", () => window.location.reload());

  content.append(title, message, retry);
  screen.append(content);
  target.replaceChildren(screen);
}

async function bootstrap(): Promise<void> {
  // Keycloak can remove OIDC callback parameters from the URL. Initialize it
  // before Vue Router reads the current location.
  await useAuthStore(pinia).initialize();

  const { router } = await import("@/router");
  app.use(router);
  await router.isReady();
  app.mount("#app");
}

// Do not use top-level await here. Lazy route chunks can import helpers emitted
// from this entry chunk; awaiting router readiness at module scope would then
// deadlock the entry chunk against the route it is trying to load.
void bootstrap().catch(renderBootstrapFailure);
